{
  "form": {
    "input_placeholder": "Shto një detyrë…",
    "parseWithAi_aria": "Analizo detyrën me AI",
    "parseWithAi_title": "Pastro dhe cakto përparësinë me AI",
    "priorityLabel_aria": "Përparësia e detyrës",
    "add": "Shto",
    "signInForAi": "Kyçu për të përdorur veçoritë AI.",
    "aiUnavailable": "AI e padisponueshme. Provo sërish.",
    "saveTo": "Ruaj në",
    "saveTo_aria": "Ruaj në {{list}}",
    "saveToSynced_aria": "Ruaj në {{list}}, {{provider}}",
    "addedTo": "U shtua në {{list}}",
    "addedToSynced": "U shtua në {{list}} · {{provider}}",
    "show": "Shfaq"
  },
  "priority": {
    "Critical": "Kritike",
    "High": "E lartë",
    "Medium": "Mesatare",
    "Low": "E ulët"
  },
  "item": {
    "edit_aria": "Redakto detyrën",
    "delete_aria": "Fshij detyrën",
    "addStep": "Shto një hap",
    "addStep_placeholder": "Shto një hap…",
    "addStep_aria": "Shto një hap te {{task}}",
    "steps_group_aria": "Hapat e {{task}}",
    "steps_progress_aria": "{{done}} nga {{count}} hapa të kryer",
    "completeSteps_aria": "{{task}}. Përfundon edhe {{count}} hapa të hapur"
  },
  "list": {
    "title": "Detyrat",
    "newListFallback": "Listë e Re",
    "completedMeta": "{{completed}} nga {{total}} të përfunduara",
    "deleteConfirm": "Të fshihet \"{{name}}\"?",
    "rename_title": "Riemërto",
    "deleteList_title": "Fshij listën",
    "newListName_placeholder": "Emri i listës…",
    "newList": "Listë e re",
    "done": "U krye",
    "emptyTitle": "Ende pa detyra",
    "emptySubtitle": "Shto një më poshtë për të filluar.",
    "noFilterMatch": "Asnjë detyrë nuk përputhet me këtë filtër.",
    "createIn": "Krijo në",
    "inDestination": "në {{destination}}",
    "createIn_aria": "Krijo në {{destination}}",
    "createInAccount_aria": "Krijo në {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Po krijohet në {{destination}}…",
    "createFailed": "Nuk u krijua dot “{{name}}” në {{destination}}.",
    "createLimit": "{{destination}} ka arritur kufirin e listave.",
    "keepInRhemn": "Mbaje në Rhemn"
  },
  "filter": {
    "label": "Filtro",
    "all": "Të gjitha"
  },
  "voice": {
    "mic_aria": "Shto detyra me zë",
    "mic_title": "Thuaji detyrat — renditen sipas përparësisë dhe kohës",
    "stop_aria": "Ndalo dhe rendit detyrat",
    "recording": "Po regjistron",
    "sorting": "Po renditen detyrat…",
    "stripTitle": "Detyrat e dëgjuara",
    "stripCount": "{{checked}} nga {{total}}",
    "discard": "Hidhe",
    "addN": "Shto {{count}}",
    "addZero": "Shto",
    "adding": "Po shtohen…",
    "parseFallback": "S'u rendit dot — fjalët e tua janë në kuti.",
    "nothingHeard": "S'u dëgjua gjë — provo sërish.",
    "micDenied": "Mikrofoni është i bllokuar — lejoje te cilësimet.",
    "gateBody": "Thuaji detyrat — renditen sipas përparësisë dhe bllokut të namazit. Përfshirë me Pro.",
    "listen_aria": "Po dëgjon — thuaji detyrat"
  }
}
